export const PAYMENT_OUTAGE_MESSAGE =
  'The system is currently down and the Clero team is working on it. Please try again soon.';
export const paymentsAreDisabled = false;

const extractErrorMessage = (error: any): string => {
  if (typeof error?.details === 'string') return String(error.details).trim();
  if (typeof error?.details?.message === 'string') return String(error.details.message).trim();
  return String(error?.message || error || '').trim();
};

const normalizeErrorCode = (error: any): string => {
  return String(error?.code || error?.details?.code || '').trim().toLowerCase();
};

export const resolvePaymentOutageMessage = (error?: any): string | null => {
  if (paymentsAreDisabled) return PAYMENT_OUTAGE_MESSAGE;

  const code = normalizeErrorCode(error);
  const message = extractErrorMessage(error);

  if (code === 'unavailable' || code === 'functions/unavailable') {
    return PAYMENT_OUTAGE_MESSAGE;
  }
  if (message === PAYMENT_OUTAGE_MESSAGE) {
    return PAYMENT_OUTAGE_MESSAGE;
  }

  return null;
};
